// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { LogoOP } from '@op/opds.opux-logo/op';
import message from '../messages';

const OpLogo: React.FC = () => {
    return (
        <div id="op-logo">
            <div className="op-logo-custom">
                <LogoOP aria-label="opLogo" className="op-logo-height-custom" label={message('opLogoHeader')} />
            </div>
        </div>
    );
};

export default OpLogo;
